import * as React from "react";
import { Grid, TextField } from "@material-ui/core";
import DropDown from "components/DropDown";
import config from "customConfig";
import EditSections from "./EditSections";

interface ListeningTestFormProps {
  listeningTest: any;
  updateListeningTest: (listeningTest: any) => void;
  isEdit?: boolean;
}

const ListeningTestForm: React.FC<ListeningTestFormProps> = ({
  listeningTest,
  updateListeningTest,
  isEdit,
}) => {
  const { book, test } = listeningTest;
  const onBookChange = (book: string) => {
    updateListeningTest((draft: any) => {
      draft.book = book;
    });
  };
  const onTestChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    updateListeningTest((draft: any) => {
      draft.test = e.target.value;
    });
  };
  return (
    <Grid container direction="column">
      <Grid item container justify="space-between">
        <Grid item>
          <DropDown
            name="Book"
            options={config.books}
            value={book}
            setValue={onBookChange}
            isEdit={isEdit}
          />
        </Grid>
        <Grid item>
          <TextField
            label="Test"
            variant="outlined"
            autoComplete="off"
            value={test}
            onChange={onTestChange}
            disabled={isEdit}
          />
        </Grid>
      </Grid>
      <Grid item>
        <EditSections
          listeningTest={listeningTest}
          updateListeningTest={updateListeningTest}
        />
      </Grid>
    </Grid>
  );
};

ListeningTestForm.defaultProps = {
  isEdit: false,
};

export default ListeningTestForm;
